export type IntegrationDetailTab = 'connections' | 'permissions';

export const resolveDefaultIntegrationDetailTab = (
    hasWorkspaceConnections: boolean
): IntegrationDetailTab => (
    hasWorkspaceConnections ? 'connections' : 'permissions'
);
